import React from 'react';
import {Modal} from 'react-bootstrap';
import css from './ErrorModal.module.css';

export type ErrorModalProps = {
  isOpen: boolean;
  onClose: () => void;
  message: string | React.ReactNode;
  additionalMeassage?: string | React.ReactNode;

  mascotUrl?: string;
  additionalMascotUrl?: string;
};

export const ErrorModal = ({
  isOpen,
  onClose,
  message,
  additionalMeassage,
  mascotUrl = 'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content%2Fcoupon-purchase%2Ferror-mascot-1.png',
  additionalMascotUrl = 'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content%2Fcoupon-purchase%2Ferror-mascot-2.png',
}: ErrorModalProps) => {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      className={css.root}
      contentClassName={css.modalContent}
      centered
      size="lg"
    >
      <Modal.Header closeButton className={css.header} />
      <Modal.Body>
        <div className="d-flex flex-column align-items-center">
          <div className={css.contentSection}>
            <p className={css.contentSectionText}>{message}</p>
            <img
              src={mascotUrl || '/images/mascot.png'}
              alt="mascot"
              className={css.mascotImg}
            />
          </div>

          {additionalMeassage && (
            <div className={css.contentSection}>
              {additionalMascotUrl && (
                <img
                  src={additionalMascotUrl}
                  className={css.mascotImg}
                  alt="mascot"
                />
              )}
              <div className={css.contentSectionText}>{additionalMeassage}</div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};
